import { call } from 'redux-saga/effects';

import { SpaceType } from '~src/spacesPlatform/state/SpaceInfo';

import { BaseTelemetryEvent, Telemetry } from '../../commonInfra/services/Telemetry';
import { TelemetryEvents } from '../../commonInfra/telemetryEvents/TelemetryEvents';
import { HomeApiPerformance } from '../telemetry/HomeTelemetryEvents';
import { ChannelTypes } from '../types/ChannelTypes';

/**
 * Since generator functions only return iterators, this hack takes advantage of closures to store information
 * that would normally be returned by a function.
 */
export interface HomeApiResult {
  apiCallResult?: any;
  contentLength: number;
}

// Default result separated for unit testing
export const ApiPerformanceTimerDefaultResult: HomeApiResult = { contentLength: 0 };

/**
 * Calls an API and sends a telemetry event with the duration of the API in ms.
 * @param apiCall: The function to time
 */
export function* apiPerformanceTimer(apiCall: (result: HomeApiResult) => void, space: SpaceType,  details: ChannelTypes | string, pageViewId: string) {
  const apiStartTime = performance.now();
  const result: HomeApiResult = Object.assign({}, ApiPerformanceTimerDefaultResult);

  yield call(apiCall, result);
  const event = generateApiTelemetryEvent(space, details, apiStartTime, result.contentLength, pageViewId);
  sendTelemetryEvent(event);

  return result.apiCallResult;
}

function generateApiTelemetryEvent(space: SpaceType, details: string, startTime: number, contentLength: number, pageViewId: string): HomeApiPerformance {
  const durationInMilliSecs = performance.now() - startTime;
  const schemaVersion = 2;
  return {
    type: TelemetryEvents.HomeApiPerformance,
    space,
    details,
    durationInMilliSecs,
    contentLength,
    pageViewId,
    schemaVersion,
  };
}

function sendTelemetryEvent(event: BaseTelemetryEvent) {
  Telemetry.sendEvent(event);
}
